(function () {
  const root = document.querySelector('.kyotaru-osechi');
  if (!root) return;

  const splideEl = root.querySelector('.js-splideKv');
  if (splideEl && window.Splide) {
    new Splide(splideEl, {
      type: 'fade',
      rewind: true,
      perPage: 1,
      arrows: false,
      pagination: false,
      drag: false,
      autoplay: true,
      interval: 5000,
      speed: 1500,
      pauseOnHover: false,
    }).mount();
  }

  // ScrollMagic onEnter equivalent (offset: 100)
  root.querySelectorAll('.js-scrollAnimation, .js-scrollAnimation03').forEach((el) => {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-animated');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -100px 0px', threshold: 0 }
      );
      observer.observe(el);
    } else {
      el.classList.add('is-animated');
    }
  });

  const intro = root.querySelector('.js-intro');
  const reserve = root.querySelector('.js-reserve');
  const pagetop = root.querySelector('.js-pagetop');
  const footer = root.querySelector('.js-footer');

  function isIntroPassed() {
    if (!intro) return window.scrollY > 200;
    return intro.getBoundingClientRect().bottom <= 0;
  }

  function updateChrome() {
    if (!reserve || !pagetop) return;
    const introPassed = isIntroPassed();
    intro?.classList.toggle('is-passed', introPassed);
    reserve.classList.toggle('is-view', introPassed);
    pagetop.classList.toggle('is-view', introPassed);
  }

  function updatePagetopPosition() {
    if (!pagetop || !reserve) return;
    const padding = window.matchMedia('(max-width: 767px)').matches ? 20 : 40;
    const reserveHeight = reserve.getBoundingClientRect().height;

    if (footer && footer.getBoundingClientRect().top <= window.innerHeight) {
      pagetop.style.position = 'absolute';
      pagetop.style.bottom = `${reserveHeight + footer.getBoundingClientRect().height + padding}px`;
    } else {
      pagetop.style.position = 'fixed';
      pagetop.style.bottom = `${reserveHeight + padding}px`;
    }
  }

  let scrollTicking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(() => {
        updateChrome();
        updatePagetopPosition();
        scrollTicking = false;
      });
    },
    { passive: true }
  );

  root.querySelector('.js-pagetop_inner')?.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  updatePagetopPosition();
  updateChrome();
})();
